;(function () {
    function Controller(wrapper) {
        /**
         * local object availability
         * @type {navigation}
         * @private
         */
        var _this = this

        var isCraftsmanActive = false

        this.showInfoText = true

        this.wrapper = wrapper

        this.form = wrapper.querySelector('[rel="contact-person-zip-code-search-form"]')

        this.results = wrapper.querySelector('[rel="contact-person-zip-code-search-results"]')

        this.headline = _this.wrapper.querySelector('[rel="contact-person-zip-code-search-headline"]')

        this.containers = _this.results?.querySelectorAll('[rel="contact-person-zip-code-search-result-container"]')

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            if (_this.form !== null) {
                if (_this.wrapper.dataset.mode !== null && _this.wrapper.dataset.mode === 'auto') {
                    // Disallow submitting the form in the backend
                    _this.form.addEventListener('submit', function (e) {
                        e.preventDefault()
                    })
                } else {
                    const urlParams = new URLSearchParams(window.location.search)
                    if (_this.form.dataset.method === 'GET') {
                        if (urlParams.get('zipcode')) _this.form.scrollIntoView({ behavior: 'smooth' })
                    } else {
                        _this.form.addEventListener('submit', function (e) {
                            e.preventDefault()
                            _this.resetVisibility()
                            _this.removeClonedElements()
                            let zipcode = _this.form.querySelector(
                                '[rel="contact-person-zip-code-search-zipcode"]'
                            ).value
                            _this.searchForZipCode(zipcode, _this.renderContactData)
                        })
                    }
                    // Search initially, if the searchinitially flag is set
                    if (
                        _this.wrapper.dataset.searchinitially !== null &&
                        _this.wrapper.dataset.searchinitially === 'true'
                    ) {
                        _this.searchForZipCode('', _this.renderContactData)
                    }
                }
            }
        }

        /**
         * Searches for the given zipcode and passes the results to the callback
         *
         * @param zipcode
         * @param callback
         */
        this.searchForZipCode = function (zipcode, callback) {
            _this.wrapper.classList.add('loading')
            // Only show info text, if a zipcode is given
            _this.showInfoText = zipcode !== ''
            let url = _this.form.dataset.target + '?searchtype=' + _this.form.dataset.searchType + '&zipcode=' + zipcode
            var xmlHttp = new XMLHttpRequest()
            xmlHttp.onreadystatechange = function () {
                if (xmlHttp.readyState === 4 && xmlHttp.status === 200) {
                    callback(JSON.parse(xmlHttp.responseText))
                    _this.wrapper.classList.remove('loading')
                }
            }
            xmlHttp.open('GET', url, true) // true for asynchronous
            xmlHttp.send(null)
        }

        /**
         * Trigger the rendering for all containers of the given plugin
         * Activate 'no results' message if no result is available
         *
         * @param contactData
         */
        this.renderContactData = function (contactData) {
            if (contactData.length === 0) {
                _this.containers.forEach(function (container) {
                    if (container.dataset.containerIdentifier === 'fallback') {
                        container.classList.add('active')
                    }
                })
                return
            }

            if (contactData[0] && contactData[0].contacts !== undefined) {
                var originalEl = _this.containers[0]
                _this.renderContactDataContainer(contactData[0], originalEl)
                contactData.shift()
                contactData.reverse().forEach((contact) => {
                    var clonedEl = originalEl.cloneNode(true)
                    var headlineEL = clonedEl.querySelector('.contact-person-search-result-headline')
                    if (headlineEL) headlineEL.remove()
                    originalEl.insertAdjacentElement('afterend', clonedEl)
                    _this.renderContactDataContainer(contact, clonedEl)
                })
                isCraftsmanActive = true
            } else if (_this.containers !== null && _this.containers.length > 0) {
                _this.containers.forEach(function (container) {
                    _this.renderContactDataContainer(contactData, container)
                })
            }
        }

        /**
         * Add the required data to the marked fields in the result template
         * Active the container if all data is available
         * Returns if there is data available for all fields
         *
         * @param contactData
         * @param container
         */
        this.renderContactDataContainer = function (contactData, container) {
            var currentContactData = null
            // get right contactData if identifier set
            if (container.dataset.containerIdentifier) {
                for (var i = 0; i < contactData.contacts.length; i++) {
                    if (contactData.contacts[i].identifier === container.dataset.containerIdentifier) {
                        currentContactData = contactData.contacts[i]
                    }
                }
                if (currentContactData === null) {
                    return false
                }
            } else {
                // use first if nothing is specified
                currentContactData = contactData.contacts[0]
                // for craftsman search
                currentContactData['zipCity'] = (currentContactData.zipCodeBranch ? currentContactData.zipCodeBranch : contactData.zipCode) + ' ' + contactData.city
                currentContactData['fax'] = currentContactData.fax
                currentContactData['phone'] = currentContactData.phone
            }

            var resultFields = container.querySelectorAll('[data-result-field]')
            var isContainerActive = false

            if (resultFields !== null && resultFields.length > 0) {
                resultFields.forEach(function (resultField) {
                    if (!_this.showInfoText && resultField.dataset.resultField === 'text') {
                        resultField.innerHTML = ''
                        return
                    }
                    var fieldValue = currentContactData[resultField.dataset.resultField]
                    if (fieldValue !== undefined && fieldValue !== '') {
                        if (
                            resultField.dataset.resultFieldType !== null &&
                            resultField.dataset.resultFieldType === 'mail-link'
                        ) {
                            resultField.setAttribute('href', 'mailto:' + fieldValue)
                        } else if (
                            resultField.dataset.resultFieldType !== null &&
                            resultField.dataset.resultFieldType === 'pdf-link'
                        ) {
                            resultField.setAttribute('href', fieldValue)
                        } else if (
                            resultField.dataset.resultFieldType !== null &&
                            resultField.dataset.resultFieldType === 'phone-link'
                        ) {
                            resultField.innerHTML = fieldValue
                            var cleanPhone = fieldValue.replace(/[^0-9]/g, '')
                            resultField.setAttribute('href', 'tel:' + cleanPhone)
                        } else {
                            resultField.innerHTML = fieldValue
                        }

                        // take care field is visible
                        resultField.style.display = ''
                        isContainerActive = true
                    } else {
                        // hide field if content is empty(important for email button)
                        resultField.style.display = 'none'
                    }
                })
            }

            if (isContainerActive) {
                container.classList.add('active')
            }

            return isContainerActive
        }

        /**
         * Reset the visibility settings for all elements
         */
        this.resetVisibility = function () {
            _this.containers.forEach(function (container) {
                _this.resetContainerActiveState(container)
                _this.resetContainerHiddenState(container)
            })

            _this.resetHeadlineHiddenStates()
        }

        /**
         * Deactivate all containers
         *
         * @param container
         */
        this.resetContainerActiveState = function (container) {
            if (container !== undefined && container.classList.contains('active')) {
                container.classList.remove('active')
            }
        }

        /**
         * Deactivate all containers
         */
        this.resetHeadlineHiddenStates = function () {
            var headlines = _this.wrapper.querySelectorAll('[rel="contact-person-search-result-headline"]')
            headlines.forEach(function (headline) {
                headline.classList.remove('hidden')
            })
            var altHeadlines = _this.wrapper.querySelectorAll(
                '[rel="contact-person-alternative-search-result-headline"]'
            )
            altHeadlines.forEach(function (altHeadline) {
                altHeadline.classList.add('hidden')
            })
        }

        /**
         * Deactivate all containers
         *
         * @param container
         */
        this.resetContainerHiddenState = function (container) {
            if (container !== undefined && container.classList.contains('hidden')) {
                container.classList.remove('hidden')
            }
        }

        /**
         * Removes cloned elements when using craftsman search
         */
        this.removeClonedElements = function () {
            if (isCraftsmanActive) {
                var elements = _this.results.querySelectorAll('.contact-person-search-result-container.active')
                for (var i = 0; i < elements.length; i++) {
                    elements[i].remove()
                }
                isCraftsmanActive = false
            }
        }

        /**
         * initialize call navigation
         */
        _this.init()
    }

    window.EnergyContactPersonZipCodeSearch = window.EnergyContactPersonZipCodeSearch || {}

    window.EnergyContactPersonZipCodeSearch.Controller = Controller
})()

/**
 * Initialize the zipcode search script for each wrapper to allow multiple plugins on one page
 */
initializeContactPersonZipCodeSearch = function () {
    let forms = document.querySelectorAll('[rel="contact-person-zip-code-search-wrapper"]')
    if (forms.length > 0) {
        forms.forEach(function (wrapper) {
            new window.EnergyContactPersonZipCodeSearch.Controller(wrapper)
        })
    }
}

if (document.readyState !== 'loading') {
    initializeContactPersonZipCodeSearch()
} else {
    initializeContactPersonZipCodeSearch()
}
